import React, { useCallback, useEffect, useState } from "react";
import DotControls from "./DotControls";
import PageCard from "./PageCard";
import useEmblaCarousel from "embla-carousel-react";
import LeftArrow from "./ArrowsButton/LeftArrow";
import RightArrow from "./ArrowsButton/RightArrow";

const FeaturedPages = ({ title, description, pages, paddingY }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    dragFree: false,
    containScroll: "trimSnaps",
    slidesToScroll: 1,
    speed: 20,
  });
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnEnabled(emblaApi.canScrollPrev());
    setNextBtnEnabled(emblaApi.canScrollNext());
  }, [emblaApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
  }, [emblaApi, onSelect]);

  function handleNext() {
    emblaApi.scrollNext();
  }

  function handlePrev() {
    emblaApi.scrollPrev();
  }
  function handleGoTo(slide) {
    emblaApi.scrollTo(slide);
  }

  return (
    <div
      className={`${paddingY ?? "py-[68px]"} md:py-[90px] box-border`}
      boxSizing="border-box"
    >
      <div className="pr-5 pl-[10px] md:pl-[30px] 2xl:pl-20 mb-[30px]">
        <h2 className="text-3xl md:text-[40px] font-bold leading-[45px] md:leading-[60px] tracking-wide text-black">
          {title}
        </h2>
        {description && (
          <div className="max-w-[700px] mt-5 text-base">{description}</div>
        )}
      </div>
      {/* Page Cards Container */}
      <div className="block relative max-w-full w-full">
        {prevBtnEnabled && <LeftArrow onClick={handlePrev} />}
        {nextBtnEnabled && <RightArrow onClick={handleNext} />}
        <div
          className="relative py-[30px] z-0 overflow-hidden pr-5 xl:pr-16"
          ref={emblaRef}
        >
          <div className="flex flex-row ml-3 sm:ml-5 xl:ml-16">
            {pages.map((page, index) => (
              <div
                key={index}
                className={`relative flex-grow-0 flex-shrink-0 block rounded-[10px] overflow-hidden 
                ${
                  pages.length === 2
                    ? "basis-[90%] md:basis-1/2"
                    : "basis-[90%] md:basis-[50%]"
                }`}
              >
                <PageCard key={index} page={page} />
              </div>
            ))}
          </div>
        </div>

        <div className="w-full flex md:hidden justify-center sm:mt-[30px]">
          <DotControls
            arr={pages}
            activeIndex={selectedIndex}
            animationDuration="500ms"
            color="black"
            onClick={(e) => handleGoTo(e.clickedIndex)}
          />
        </div>
      </div>
    </div>
  );
};

export default FeaturedPages;
